import React from "react";

interface StatusIndicatorProps {
  deviceStatus?: string;
  // Text to show instead of deviceStatus, e.g. "Disconnected from myQ" for the "disconnected" status.
  label?: string;
  count?: number | string;
  transparent?: boolean;
}

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ deviceStatus, label, count, transparent }) => {
  if (!deviceStatus) return <>-</>;
  const transparentClass = transparent ? " transparent" : "";

  return (
    <div className={`status-indicator ${deviceStatus}${transparentClass}`}>
      <div className={`status-dot ${deviceStatus}`} />
      <span className={`status-text ${deviceStatus}`}>
        {count !== undefined && `${count} `}{label || deviceStatus}
      </span>
    </div>
  );
};

export default StatusIndicator;
